var render, staticRenderFns
import script from "./ToolbarHeader.vue?vue&type=script&lang=js&"
export * from "./ToolbarHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ToolbarHeader.vue"
export default component.exports